import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-bill-summary",
  templateUrl: "./billsummary.component.html",
  styleUrls: ["./billsummary.component.css"],
})
export class BillSummaryComponent implements OnInit, OnChanges {
  @Input() summary!: any;
  @Input() account!: any;
  @Input() highestspend!: any;
  @Input() monthYear = "";
  @Input() mode: any;

  formattedMonthYear = "";

  ngOnInit(): void {
    this.updateFormattedMonthYear();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["monthYear"] && !changes["monthYear"].firstChange) {
      this.updateFormattedMonthYear();
    }
  }

  private updateFormattedMonthYear(): void {
    this.formattedMonthYear = this.formatMonthYear(this.monthYear);
  }

  private formatMonthYear(value: string): string {
    if (!value) {
      return "";
    }

    const [monthStr, yearStr] = value.split("-");
    const month = Number(monthStr);
    const year = Number(yearStr);

    if (Number.isNaN(month) || Number.isNaN(year)) {
      return value;
    }

    const date = new Date(year, month - 1);
    const monthName = date.toLocaleString("default", { month: "long" });

    return `${monthName} - ${year}`;
  }
}
